import {connect} from 'react-redux';
import { isNZLocale } from 'lib/PropertyUtils';
import { get } from 'lodash';
import Routes from './Routes';
import S3Util from 'lib/S3Util';

const mapStateToProps = (state) => {
  const defaultRpdBaseUrl = isNZLocale()
      ? 'https://propertyguru.corelogic.co.nz'
      : 'https://rpp.corelogic.com.au';

  const rpdBaseUrl = get(state.settings, 'rpd.baseUrl', defaultRpdBaseUrl);
  return {
    rpdBaseUrl,
    loggedIn: state.login.loggedIn,
    reportTypeValue: state.reportType.value,
    featureFlags: state.featureFlags,
    favicon: S3Util.getAssetDomain('/logos/favicon.png'),
  };
};

export default connect(mapStateToProps)(Routes);